import { render, staticRenderFns } from "./EmailWrapper.vue?vue&type=template&id=398a4e0c"
import script from "./EmailWrapper.vue?vue&type=script&lang=js"
export * from "./EmailWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports